/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/08/01
 * @created by      :   ANS902 – quanlh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

const dataInit = {
    department_cd: '',
    department_name: '',
    mode: 0,
    pageSize: 10,
    pageNo: 1
};

export default {
    namespaced: true,
    state: {
        listData: [],
        data: { ...dataInit },
        msgNoData: '該当するデータが存在しません。',
        totalRows: 0
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません。';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setTotalRows(state, data) {
            state.page_no = data.page ?? [];
            state.page_size = data.pagesize ?? [];
            state.totalRows = data.total_rows;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        },
        setMessage(state, data) {
            state.msgNoData = data;
        }
    },
    actions: {
        /**
         * search area info
         * -----------------------------------------
         * @author : hainn - 2024/10/16 - create
         * @params :
         * @access : private
         */
        searchAreaInfo(context) {
            try {
                context.commit('setListData', [
                    {
                        department_cd: 1,
                        department_name: '東日本統括部'
                    },
                    {
                        department_cd: 2,
                        department_name: '東日本統括部2'
                    }
                ]);
                context.commit('setTotalRows', 1);
            } catch (e) {
                console.log('searchCommonAreaInfo: ' + e.message);
            }
        }
    }
};
